<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M3 14h18v-2H3m2-8v3h5v3h4V7h5V4m-9 15h4v-3h-4v3z"/>
    </svg>
</template>

<script>
export default {
    name: 'FormatStrikethroughIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
